/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter values to calculate.`)
};

const es_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce los valores para calcular.`)
};

const de_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werte zum Berechnen eingeben.`)
};

const nl_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul waarden in om te berekenen.`)
};

const fr_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez des valeurs pour calculer.`)
};

const it_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci i valori da calcolare.`)
};

const pt_br2_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira os valores para calcular.`)
};

const pt_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira os valores para calcular.`)
};

const ja_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計算する値を入力してください。`)
};

const zh_pct_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入数值进行计算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_enter_values = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_enter_values(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_enter_values", locale)
	if (locale === "en") return en_pct_enter_values(inputs)
	if (locale === "es") return es_pct_enter_values(inputs)
	if (locale === "de") return de_pct_enter_values(inputs)
	if (locale === "nl") return nl_pct_enter_values(inputs)
	if (locale === "fr") return fr_pct_enter_values(inputs)
	if (locale === "it") return it_pct_enter_values(inputs)
	if (locale === "pt-BR") return pt_br2_pct_enter_values(inputs)
	if (locale === "pt") return pt_pct_enter_values(inputs)
	if (locale === "ja") return ja_pct_enter_values(inputs)
	return zh_pct_enter_values(inputs)
};